module.exports = __webpack_public_path__ + "img/weempowerconsumers.f2ff3ee3.png";